import { OPPORTUNITY_ACTIONS } from "./OPPORTUNITY_ACTIONS"


export function opportunityReducer(state, action) {
  switch (action.type) {
    case OPPORTUNITY_ACTIONS.SET_OPPORTUNITY:
      return {
        ...state,
        opportunity: action.payload.opportunity,
      }
    case OPPORTUNITY_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}